module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('topbar'), " ", _h('my-header'), " ", _h('navbar'), " ", _h('div', {
    staticClass: "app-container"
  }, [_m(0), " ", _h('profile', {
    attrs: {
      "profile": data.profile
    }
  }), _h('router-view', {
    attrs: {
      "data": data
    }
  })])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "spacer"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 24
 ** module chunks = 1
 **/